import { IDecree } from '../DecreeCard/DecreeCard-types';
import { IPlayerGameState } from '../Player/Player-types';
import { IUnit, IUnitType } from '../Unit/Unit-types';

export const CONTROL_BASES = [
    '0,2', '0,5', '1,0', '1,3', '2,1',
    '2,6', '3,2', '3,4', '4,0', '4,5',
    '5,3', '5,6', '6,1', '6,4',
];

export const FOUR_PLAYER_TILES = [
    '0,1', '0,2', '1,0', '1,1', '2,0',
    '4,6', '5,5', '5,6', '6,4', '6,5',
];

export const THEME_TOURNAMENT_KIT = 'TK';

export interface ITeamResource {
    id: number;
    gameId: number;
    color: string;
    controlledBases: string[];
	winningScore: number | null;
}

export interface IFortResource {
    id: number;
    gameId: number;
    position: string;
    teamId: string;
}

export interface IPoisonToken {
    id: number;
    gameId: number;
    ownerUnitTypeId: number;
    assignedUnitId: number;
}

export interface IGameSettings {
    altFootman: boolean;
    altLancer: boolean;
    altMarshal: boolean;
    blitz: boolean;
	nobility: boolean;
    nightfall: boolean;
    siege: boolean;
    champions: boolean;
	highSeas: boolean;
    mastery: boolean;
    shock: boolean;
    twoPlayersFullBoard: boolean;
    theme: string;
    updatedAt: string;
	queueMode: boolean;
}

export interface IGameState {
    state: {
        altFootman: boolean;
        altLancer: boolean;
        altMarshal: boolean;
        activePlayerId: number | null;
		champions: boolean;
        choosePlayOrder: boolean;
        creatorId: string | null;
        customUnitTypes: string[];
        customUnits: boolean;
        decrees: IDecree[];
        draft: boolean;
        draftType: string;
        draftingPlayerId: number | null;
        facedownUnits: IUnit[];
        forts: IFortResource[];
		highSeas: boolean;
        loaded: boolean;
        mastery: boolean;
        nobility: boolean;
        numOfPlayers: number | null;
        passwordRequired: boolean;
        players: IPlayerGameState[];
		queueMode: boolean;
        ranked: boolean;
        roomName: string;
        royalGuardType: boolean;
        nightfall: boolean;
        siege: boolean;
        state: string | null;
        teams: ITeamResource[];
        theme: string | null;
        timeLimit: number | null;
        turnOrder: number[];
        unitTypes: IUnitType[];
        unitsInBag: IUnit[];
        unitsInHand: IUnit[];
        updatedAt: string | null;
        updatedSkillRating: number | null;
        winningTeamId: number | null;
        winningScore: number;
        poisonTokens: IPoisonToken[];
        twoPlayersFullBoard: boolean;
    },
    mutations: {

    },
    actions: {

    },
    getters: {

    },
}

export const IGameStatus = {
    WAITING_FOR_PLAYERS: 'waiting_for_players',
    WAITING_FOR_TEAM_SELECTION: 'waiting_for_team_selection',
    READY_TO_START: 'ready_to_start',
    DRAFTING: 'drafting',
    ELIMINATION_DRAFTING: 'elimination_drafting',
    STARTED: 'started',
    ENDED: 'ended',
    CANCELLED: 'cancelled',
    SELECTING_DRAFT_ORDER: 'selecting_draft_order',
    SELECTING_PLAY_ORDER: 'selecting_play_order',
};

export const IDraftType = {
    RANDOM: 'random',
    DRAFT: 'draft',
    ELIMINATION_DRAFT: 'elimination_draft',
};

export interface IGameResource {
    activePlayerId: number;
    createdAt: string;
    creatorId: number;
    draftType: string;
    draftingPlayerId: number;
    id: number;
    initiativeTakenRound: number;
    numOfPlayers: number;
    ranked: boolean;
    roomName: string;
    round: number;
    state: string;
    turnOrder: number[];
    updatedAt: string;
    winningScore: number;
    winningTeamId: number;
    startedAt: string;
}

export interface IGameStateResponse extends IGameResource {
    activePlayerId: number;
    choosePlayOrder: boolean;
    creator: {
        uuid: string;
    };
    customUnitTypes: string[];
    customUnits: boolean;
    decrees: IDecree[];
    draft: boolean;
    draftingPlayerId: number;
    forts: IFortResource[];
    passwordRequired: number;
    players: IPlayerGameState[];
    royalGuardType: boolean;
    teams: ITeamResource[];
    timeLimit: number;
    poisonTokens: IPoisonToken[];
    settings: IGameSettings;
}

export const IColor = {
    WHITE: 'white',
    BLACK: 'black',
};
